import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../../lib/utils';

const tagVariants = cva(
  'items-center rounded-full tracking-[-0.01em] border px-1.5 py-[0.1875rem] text-[0.625rem] font-semibold transition-colors',
  {
    variants: {
      variant: {
        default:
          'bg-tertiary border-bg_secondary text-tertiary font-medium leading-[1.3em]'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
);

export interface TagProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof tagVariants> {}

function Tag({ className, variant, ...props }: TagProps) {
  return <div className={cn(tagVariants({ variant }), className)} {...props} />;
}

export { Tag, tagVariants };
